import React from 'react';
import { Link } from 'react-router-dom';
import { GIFT_CARD_SVG } from '../staticTypes';
import { trackSharePop } from '../../Utils/blogs'

import Header from './Header'

const Ways = (props) => {
	const { points } = props.data;
	const { onClick, launcherFlag, visitorId, email } = props
	const onConvertPoints = () => {
		trackSharePop(email, visitorId, 'convert-points')
	}

	return (
		<div id="ways" className="ways-rewards">
			<Header points={points} onClick={onClick} launcherFlag={launcherFlag} link="/" />
			<div>
				<div className="panel-container with-join-program-footer">
					<div className="panel-subview">

						<div className="card-heading-container ">
							<div className="card-title heading ">Ways to redeem</div>
						</div>

						<div className="card-list-container ">
							<div className="card-list-item">
								<div className="card-list-item-content">
									{GIFT_CARD_SVG}
									<div className="list-item-text-wrapper">
										<div className="list-item-title">Order discount</div>
										<div className="list-item-subtitle text-muted">100 Points = $1</div>
									</div>
								</div>
								{
									points >= 100 ?
										<Link to="/convert-points" onClick={ onConvertPoints }>
											<button className="btn btn-sm btn-primary customer-points-products-button"
												style={{ padding: '10px 16px', width: 'auto', height: 'auto' }}>
												Redeem
										</button></Link>
										:
										''
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Ways;